/**
 * Created by hj on 2017/8/16.
 */
import React from 'react';
import Reflux from 'reflux';
import {Button, Upload, Icon} from 'antd';
import {hashHistory, withRouter} from 'react-router';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice} from 'Utils';
import {downLoadTemplate, toImportExcel} from 'Utils';
import {materialScreening2} from '../../service/inventoryQuery';
import {objectSerial, config} from 'Utils';
import {
    getStockList,
    setProductUp,
    setProductDown,
    getProductCategory,
    getSubStoreList,
    tiaozhengAdd,
    getStockListAmount
} from '../../service/product';
import {Store, Actions} from './store';
import {message} from "antd/lib/index";

class StockControlList extends Reflux.Component {
    constructor(props) {
        super(props);
        this.store = Reflux.initStore(Store); //创建一个Store实例
        this.state = {
            opts: ['库存管理'],
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            saveVisible: false,
            transferVisible: true,
            tiaozheng: [],
            searchObj: {
                name: '',
                s: 10,
                subStoreId: '',
                storeWarn: '',
                p: 1,
                countStart: '',
                countEnd: '',
            },
            tiaozhengObj: {},
            objType_type: [],
            objType_type2: [],
            button_limits_end: {},
            loading: true,
            amount: ''
        };
        this.pageChange = this.pageChange.bind(this);
        this.changeHandle = this.changeHandle.bind(this);
        this.visibleChange = this.visibleChange.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.routeLeaveHook = this.routeLeaveHook.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }

    goView(url) {
        hashHistory.push(url);
    }

    goAdd() {
        let self = this;
        tiaozhengAdd(this.state.tiaozheng).then((result) => {
            if (result && result.code == 200) {
                openNotice('success', (result && result.message) ? result.message : '', '');
                self.initData();
            } else {
                openNotice('error', (result && result.message) ? result.message : '', '');
            }
        })
        this.setState({saveVisible: !this.state.saveVisible});
    }

    goChange() {
        this.setState({saveVisible: true, transferVisible: false});
    }

    changeAmount = (record, e) => {
        // if (e.target.value < 0){
        // 	openNotice('warning', '数量不能为负数！');
        // 	return;
        // } else if (record.count < e.target.value) {
        // 	openNotice('warning', '调整库存不能大于现有量！');
        // 	return;
        // } else {
        this.state.tiaozhengObj[record.id] = {
            id: record.id,
            count: e.target.value
        }
        this.setState({
            tiaozheng: Object.values(this.state.tiaozhengObj)
        });
        // obj.id = record.id;
        // obj.count = e.target.value;
        // this.state.tiaozheng.push(obj);
        // console.log(this.state.tiaozhengObj)
        // this.setState({tiaozheng: this.state.tiaozheng});
        // }
    }

    goDelete() {
        alert('正在删除');
    }

    changeHandle({item, key, keyPath}) {
        this.setState({key});
    }

    visibleChange() {
        this.setState({filterBoxVisible: !this.state.filterBoxVisible});
    }

    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                name: '',
                s: 10,
                subStoreId: '',
                storeWarn: '',
                p: 1,
                countStart: '',
                countEnd: '',
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }, loading: true
        }, function () {
            self.initData();
        });
    };

    setFilterParam(name, value) {
        this.setState({searchObj: {...this.state.searchObj, [name]: value}})
    };

    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}, loading: true}, function () {
            self.initData();
        });
    }

    updateProductStatusFn(key) {
        /* 产品上下架 */
        if (this.state.selectedRowKeys.length === 0) {
            openNotice('warning', '请选择产品');
            return;
        }
        let params = {
            'ids': this.state.selectedRowKeys
        };
        let self = this;
        if (key == 'up') {
            setProductUp(params).then(function (result) {
                if (result && result.code == 200) {
                    openNotice('success', '上架操作成功', '');
                    self.initData();
                } else {
                    openNotice('error', '上架操作失败', (result && result.message) ? result.message : '');
                }
            });
        } else {
            setProductDown(params).then(function (result) {
                if (result && result.code == 200) {
                    openNotice('success', '下架操作成功', '');
                    self.initData();
                } else {
                    openNotice('error', '下架操作失败', (result && result.message) ? result.message : '');
                }
            });
        }
    }

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        getSubStoreList({p: 1, s: 9999}).then(function (SubStoreList) {
            if (SubStoreList && SubStoreList.code == 200) {
                getStockList(searchObj).then(function (result) {
                    if (result && result.code == 200) {
                        for (var i = 0; i < result.data.length; i++) {
                            for (var j = 0; j < SubStoreList.data.length; j++) {
                                if (result.data[i].subStoreId == SubStoreList.data[j].id) {
                                    result.data[i].subStoreNumber = SubStoreList.data[j].subStoreNumber;
                                    break;
                                }
                            }
                        }
                        self.setState({
                            'rows': result.data || [],
                            'total': result.total,
                            loading: false
                        });
                        getStockListAmount(searchObj).then(function (result) {
                            if (result && result.code == 200) {
                                self.setState({amount: result.data})
                            }
                        })
                    } else {
                        openNotice('error', '数据获取失败', '');
                        this.setState({loading: false});
                    }
                });
            } else {
                openNotice('error', '数据获取失败', '');
                this.setState({loading: false});
            }
        });
    }

    //离开当前路由时，更新store
    routeLeaveHook(nextLocation) {
        let path = nextLocation.pathname.split('/');
        if (path[1] === 'product') { //当下一个路由是详情页时，将useStore的值设为true
            Actions.useStoreChange(true);
            Actions.paramChange(this.state.searchObj);
        } else {
            Actions.useStoreChange(false);
            Actions.paramChange({});
        }
    }

    /*下载模板*/
    downloadChange() {
        downLoadTemplate(7);
    }

    componentWillMount() {
        let self = this;
        const data = this.store.state;
        if (data.useStore) { //根据useStore的值判断是否使用store中的数据
            this.setState({
                ...this.state,
                searchObj: {
                    ...this.state.searchObj,
                    ...data.params
                },
                key: data.params.buyerStatus || 0
            });
        }
        getSubStoreList({
            removeFlag: 0,
            s: 1000,
            p: 1,
        }).then(res => {
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                res.data.forEach(x => {
                    arr.push({
                        text: x.subStoreName,
                        value: x.id
                    })
                });
                self.setState({objType_type: arr})
            }

        });
    }

    componentDidMount() {
        this.initData();
        //设置离开当前路由时的钩子函数
        this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
        this.setState({
            button_limits_end: JSON.parse(window.localStorage.getItem("button_limits_end"))
        });
    }

    /*导出*/
    exportChange = () => {
        let _searchObj = {...this.state.searchObj};
        delete _searchObj.s;
        delete _searchObj.p;
        let url = `${config.server}/api/v1/dms/dmsTianGoodsStore/exportExcel?${objectSerial(_searchObj)}`;
        window.open(url);
    };

    render() {
        const {opts, key, rows, total, searchObj, saveVisible, transferVisible, selectedRowKeys, objType_type, button_limits_end, loading} = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'name',
                    label: '物料编号/描述',
                    text: '请输入关键字',
                    type: 'default',
                    defaultValue: searchObj.name
                },
                {
                    name: 'countStart',//startCreatedDate, endCreatedDate
                    label: '数量 从',
                    defaultValue: searchObj.countStart
                    // type: 'default',
                },
                {
                    name: 'countEnd',//startCreatedDate, endCreatedDate
                    label: '至',
                    defaultValue: searchObj.countEnd
                    // type: 'default',
                },
                {
                    name: 'subStoreId',
                    label: '子库存',
                    text: '选择子库存',
                    options: objType_type,
                    defaultValue: searchObj.subStoreId,
                    multiple: false,//支持多选
                    type: 'select'
                },
                {
                    name: 'storeWarn',
                    label: '库存预警',
                    text: "全部",
                    options: [
                        {value: '0', text: '全部'},
                        {value: 'Y', text: '正常'},
                        {value: 'N', text: '库存预警'},
                    ],
                    type: 'select'
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,//更新表格数据中
            rowKey: 'id',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            columns: [
                {
                    title: '物料编码',
                    dataIndex: 'code',
                    width: 120,
                }, {
                    title: '物料描述',
                    dataIndex: 'name',
                    width: 500
                }, {
                    title: '物料类别',
                    dataIndex: 'type',
                }, {
                    title: '单位',
                    dataIndex: 'unit',
                }, {
                    title: '子库存',
                    dataIndex: 'storageName'
                }, {
                    title: '子库编码',
                    dataIndex: 'subStoreNumber'
                }, {
                    title: '库存上限',
                    dataIndex: 'storeMax',
                }, {
                    title: '库存下限',
                    dataIndex: 'storeMin',
                }, {
                    title: '装箱数',
                    dataIndex: 'packageQuantity',
                }, {
                    title: '现有量',
                    dataIndex: 'count',
                },
                {
                    title: '价格',
                    dataIndex: 'showPrice',
                }, {
                    title: '金额',
                    dataIndex: 'amount',
                    render: (text, record, index) => {
                        return <span>{(record.count * record.showPrice).toFixed(2)}</span>
                    }
                },
                {
                    title: '调整后库存',
                    dataIndex: 'count1',
                    // render: (text, record, index) => <FormItem label={null} hasFeedback style={{ marginBottom: '0px' }}>
                    // 	{getFieldDecorator(`storageNum_${record.productSpecId}`, {
                    // 	initialValue: record.storageNum || 1,
                    // 	rules: [
                    // 		{
                    // 		required: true,
                    // 		message: '入库数量不能为空'
                    // 		},
                    // 	],
                    // 	getValueFromEvent: (e) => {
                    // 		this.productInfoChange(index, 'storageNum', e);
                    // 		return e;
                    // 	}
                    // 	})(<InputNumber min={1}
                    // 					style={{ width: '100%' }}/>)}
                    // </FormItem>

                    render: (text, record, index) => {
                        // return <Input style={{width:150}}/>
                        // return <InputNumber min={0} max={record.unWritenoffCount} onChange={this.changeAmount.bind(this, index, record)} />
                        return <input min={0} max={record.unWritenoffCount} type='number'
                                      style={{display: saveVisible ? 'inline-block' : 'none'}}
                                      onChange={this.changeAmount.bind(this, record)}/>
                    }
                }
            ],
            rows
            // rowSelection: {
            // 	selectedRowKeys,
            // 	onChange: this.onSelectChange
            // }
        };
        let uploadParam = toImportExcel(7,
            () => {
                this.initData();
            });


        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content"><AdvanceFormNew  {...filterBoxProps} /></div>
            </div>
            <div className="dms-table-box">
                <div className="dms-table-head">
                    {button_limits_end.stockControl_list_05 && <Upload {...uploadParam}>
                        <Button style={{position: 'absolute', bottom: 8, right: 88}}>
                            <Icon type="upload"/>导入
                        </Button>
                    </Upload>}
                    {button_limits_end.stockControl_list_06 && <Button onClick={this.downloadChange} style={{
                        position: 'absolute',
                        bottom: 8,
                        right: 176
                    }}>下载模板</Button>}
                    <Button onClick={this.goAdd.bind(this)}
                            style={{
                                display: saveVisible ? 'inline-block' : 'none', position: 'absolute',
                                bottom: 8,
                                right: 270
                            }}>保存</Button>
                    {button_limits_end.stockControl_list_02 && <Button onClick={this.goChange.bind(this)}
                                                                       style={{
                                                                           display: saveVisible ? 'none' : 'inline-block',
                                                                           position: 'absolute',
                                                                           bottom: 8,
                                                                           right: 270
                                                                       }}>库存调整</Button>}
                    {button_limits_end.stockControl_list_03 &&
                    <Button onClick={this.goView.bind(this, '/stockControl/sublibraryTransfer')}
                            style={{position: 'absolute', bottom: 8, left: 0}}>子库转移</Button>}
                    {button_limits_end.stockControl_list_04 &&
                    <Button onClick={this.goView.bind(this, '/stockControl/sundryInStorage')}
                            style={{position: 'absolute', bottom: 8, left: 94}}>杂项入库</Button>}
                    <Button onClick={this.goView.bind(this, '/stockControl/sundryOutStorage')}
                            style={{position: 'absolute', bottom: 8, left: 188}}>杂项出库</Button>}
                    <Button icon="export" onClick={this.exportChange} style={{
                        position: 'absolute',
                        bottom: 8,
                        right: 0
                    }}>导出</Button>

                </div>
                <TableView {...tableViewProps} />
                <div><span>汇总金额：{this.state.amount}</span></div>
            </div>
        </div>
    }
}
;

export default withRouter(StockControlList);


// WEBPACK FOOTER //
// ./src/routes/stockControl/list.js